import React from 'react';
import _ from 'lodash';

import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {
  BreakClauseTable,
  BreakClauseNoticeRecordForm,
  Buttons
} from './components';

import {MODALS, fetchBreakClause} from 'ducks/tenancy';
import {fetchBooking} from 'ducks/bookings';

import './styles.css';

class BreakClauseNoticeRecordModal extends React.Component<any> {
  triggerFormSubmit = () => {
    this.props.submit('breakClauseNoticeRecord');
  };

  componentDidMount() {
    const fetchBreakClauseExtraAction = this.props.storeDataExtraActions(
      data => ({breakClause: data})
    );
    const {tenancyId} = this.props;
    this.props.fetchBreakClause({tenancyId}, fetchBreakClauseExtraAction);
  }
  getSuccessExtraActions = () => [
    ...this.props.closeModalExtraActions,
    () => {
      const {locationRef, bookingId} = this.props.match.params;
      return fetchBooking({bookingId, locationRef});
    }
  ];

  getFailureExtraActions = () =>
    this.props.storeDataExtraActions(warnings => ({
      warnings
    }));

  render() {
    const {
      form: {submitting},
      tenancyId,
      tenancy,
      primaryTenant,
      data
    } = this.props;

    const breakClause = _.get(this.props, 'data.breakClause');

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="BreakClauseNoticeRecordModal"
        type={Modal.EXTRA_SMALL}>
        <Modal.Header heading="Record Break Clause Notice" />
        <Modal.Body>
          {breakClause &&
            tenancy && (
              <BreakClauseTable
                period={tenancy.period}
                breakClause={breakClause}
                primaryTenant={primaryTenant}
              />
            )}
          <BreakClauseNoticeRecordForm
            tenancyId={tenancyId}
            warnings={data.warnings}
            getSuccessExtraActions={this.getSuccessExtraActions}
            getFailureExtraActions={this.getFailureExtraActions}
          />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.triggerFormSubmit}
            submitting={submitting}
            onClose={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  form: {
    submitting: isSubmitting('breakClauseNoticeRecord')(state)
  }
});

const mapDispatchToProps = {
  fetchBreakClause,
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal(
  MODALS.BREAK_CLAUSE_NOTICE_RECORD
)(BreakClauseNoticeRecordModal) as React.ComponentType<any>);
